import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientRedirector"] */ "/vercel/path0/src/components/ClientRedirector.tsx");
